import React, { Component } from 'react';
import { connect } from 'react-redux';

import CLIENT from '../../../utils/restClient';

import BusySpinner from '../../spinners/BusySpinner'

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const isUrl = require('is-url');
const log = new Logger('PDF_URI_VIEWER', LOG_LEVELS.DEBUG);
class PdfUriViewer extends Component {

  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.setErrorState = this.setErrorState.bind(this);
    this.setSuccessState = this.setSuccessState.bind(this);
    this.fetchAndPreview = this.fetchAndPreview.bind(this);
    this.state = {
      loading: false,
      data: undefined,
      error: undefined
    };
  }

  render() {
    log.debug('render(): ', this.props);
    return (
      <div>
        {!this.state.loading && this.state.data ?
          (<object data={this.state.data} type="application/pdf" width="100%" height="1150px" />)
          :
          (<BusySpinner busy={this.state.loading}/>)
        }
      </div>
    );
  }

  fetchData(callback=()=>{}) {
    log.debug('fetchData() ');
    if(!isUrl(this.props.uri)) {
      callback(null, new Error("Invalid uri!"));
      return;
    }
    CLIENT.getFilingDocumentAsBlob('PDF', this.props.uri)
      .then((response) => {
        log.debug('fetchData(): getFilingDocumentAsBlob got a response ');
        callback(response, null);
      })
      .catch((error) => {
        log.error('fetchData(): getFilingDocumentAsBlob got an error   ', error);
        callback(null, error);
      });
  }

  setErrorState(error) {
    log.debug('setErrorState() - error: ', error);
    this.setState({
      loading: false,
      data: undefined,
      error: error
    });
  }

  setSuccessState(data) {
    log.debug('setSuccessState() - data: ', data);
    this.setState({
      loading: false,
      data: URL.createObjectURL(data),
      error: undefined
    });
  }

  fetchAndPreview() {
    log.debug('fetchAndPreview(): ');
    this.setState({
      loading: true
    });
    this.fetchData((response, error) => {
      if(error){
        this.setErrorState(error);
        return;
      }      
      this.setSuccessState(response);
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.uri !== this.props.uri) {
      if(this.props.uri) {
        this.fetchAndPreview();
      }
    }
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    if(this.props.uri) {
      this.fetchAndPreview();
    }
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(PdfUriViewer);
